module.exports = __webpack_public_path__ + "static/media/truck-ramp.65c608d7.svg";